import React, { useState } from 'react';

const StockNotificationForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const { variant } = props;
  const [email, setEmail] = useState('');

  if (!variant || variant.available) {
    return null;
  }

  const handleSubmit = (e) => {
    setLoading(true);
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variant.id}`,
            },
          },
        },
      },
    };

    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15',
      },
      body: JSON.stringify(payload),
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=XHrvSu`, requestOptions)
      .then((result) => setResponse(result))
      .catch((error) => console.log('error', error))
      .finally(() => setLoading(false));
  };

  return (
    <div className="notify-me">
      <div>This product is currently unavailable. To be notified once back in stock, please add your email below:</div>
      {response && response.status === 202 && (
        <div className="confirmation">Thank you! We will notify you once this product is back in stock.</div>
      )}
      {!response && (
        <div className="form-row">
          <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <button type="button" disabled={!email || loading} onClick={handleSubmit}>
            {loading ? 'Sending' : 'Notify Me'}
          </button>
        </div>
      )}
    </div>
  );
};

export default StockNotificationForm;
